import { Skeleton } from '../../ui/skeleton'

const OrgCardSkeleton = () => {
  return <Skeleton className="flex h-87 w-full rounded-2xl bg-card shadow-border" />
}

export { OrgCardSkeleton }
